import { apiRequest, buildUrl } from './index';

function captureBase(accessKey, taskId) {
  return `/v1/assets/access_key/${encodeURIComponent(accessKey)}/tasks/${encodeURIComponent(taskId)}/captures`;
}

export async function createTaskCapture(accessKey, taskId, { fieldEngineerId, media }) {
  const body = {
    media,
    ...(fieldEngineerId ? { field_engineer_id: fieldEngineerId } : {}),
  };
  const url = buildUrl(captureBase(accessKey, taskId));
  return apiRequest(url, { method: 'POST', body });
}

export async function completeTaskCapture(accessKey, taskId, captureId, { fieldEngineerId } = {}) {
  const body = fieldEngineerId ? { field_engineer_id: fieldEngineerId } : {};
  const url = buildUrl(`${captureBase(accessKey, taskId)}/${encodeURIComponent(captureId)}`);
  return apiRequest(url, { method: 'PATCH', body });
}

export async function fetchTaskCaptureDownload(
  accessKey,
  taskId,
  captureId,
  { fieldEngineerId, variant = 'thumbnail' } = {}
) {
  const url = buildUrl(`${captureBase(accessKey, taskId)}/${encodeURIComponent(captureId)}/download`, {
    ...(fieldEngineerId ? { field_engineer_id: fieldEngineerId } : {}),
    variant,
  });
  return apiRequest(url);
}
